import withInjection from '@piconetworks/with-injection'
import ConvertGift from 'common/components/ConvertGift'
import Loader from 'common/modules/loader'

const mapStateToProps = (state, props) => ({
    ...props,
    wizardName: props.router.query.id,
    optionId: Loader.selectors.currentProductOptionId(state),
})

const InjectedConvertGift = withInjection(ConvertGift, {
    mapStateToProps,
})

export default InjectedConvertGift
